<template>
<v-list-item @click="$emit('go-to-npo', npo.npo_id)">
    <v-list-item-avatar>
      <v-icon
        v-if="!npo.logo"
        class="primary lighten-1"
        dark
        v-text="'mdi-favorite'"
      ></v-icon>
      <v-img
      v-if="npo.logo"
      contain
      :aspect-ratio="1 / 1"
      :src="
        'data:image/png;base64,' + npo.logo ||
        'https://via.placeholder.com/640x200/DFDFDF?Text=Npo+image'
      "
    ></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title v-html="npo.name"></v-list-item-title>
      <v-list-item-subtitle v-html="npo.description"></v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  props: {
    npo: {
      type: Object
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      styleObject: {
        transform: 'translate(0px, 0px)'
      },
      selected: false,
      leadId: null,
      campaignId: null
    }
  },

  mounted () {
    if (JSON.parse(sessionStorage.getItem('campaign'))) {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      this.campaignId = campaign.campaign_id
    } else {
      this.campaignId = sessionStorage.getItem('campaign_id')
      this.leadId = sessionStorage.getItem('lead_id')
    }
  }
}
</script>
